import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { HaldorBlockConsumer } from '@haldor/ui';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';
import { useTranslate } from 'lib/translate';
import TeacherAssessmentBlock from './Blocks/TeacherAssessmentBlock/TeacherAssessmentBlock';

var BlockConsumer = function BlockConsumer(props) {
  var _getFields;

  var translate = useTranslate();

  var getFields = function getFields() {
    var _props$assessment, _props$assessment$ass;

    var assessmentFeedback = ((_props$assessment = props.assessment) === null || _props$assessment === void 0 ? void 0 : (_props$assessment$ass = _props$assessment.assessmentFeedbacks) === null || _props$assessment$ass === void 0 ? void 0 : _props$assessment$ass.length) > 0;
    var assessmentBlocks = props.fields.filter(function (s) {
      return assessmentFeedback || s.resources.some(function (r) {
        var _r$assessmentBlockPar;

        return r.referenceType == 'assessmentonlyfeedback' && !props.isStudent || r.assessmentBlockPartRows != null && ((_r$assessmentBlockPar = r.assessmentBlockPartRows) === null || _r$assessmentBlockPar === void 0 ? void 0 : _r$assessmentBlockPar.length) > 0;
      });
    });
    return assessmentBlocks.sort(function (a, b) {
      return a.sortorder - b.sortorder;
    }).map(function (field) {
      var label = translate('Teacher assessment');

      if (field.assessmentType == ASSESSMENT_TYPES.PEER) {
        label = translate('Peer review');
      }

      if (field.assessmentType == ASSESSMENT_TYPES.SELF) {
        label = translate('Self assessment');
      }

      var ofType = assessmentBlocks.filter(function (block) {
        return block.assessmentType == field.assessmentType;
      });
      var foundIndex = ofType.findIndex(function (b) {
        return b.id == field.id;
      });
      field.title = label + ' ' + (foundIndex + 1);
      return field;
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "assessment-block"
  }, ((_getFields = getFields()) === null || _getFields === void 0 ? void 0 : _getFields.length) > 0 ? /*#__PURE__*/React.createElement("h3", {
    style: {
      marginBottom: '1rem',
      fontWeight: 500
    }
  }, translate('Assessment')) : null, /*#__PURE__*/React.createElement(HaldorBlockConsumer, _extends({
    plugins: [TeacherAssessmentBlock],
    translate: translate
  }, props, {
    fields: getFields()
  })));
};

export default BlockConsumer;